export default "__VITE_ASSET__Z5Q6$9QP__"